import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';

const CommentAttachment = ({ attachment = {} }) => (
    <>
        {attachment.contentType.startsWith('image') ? (
            <div className="my-2">
                <a
                    href={attachment.attachmentUri}
                    rel="noreferrer"
                    target="_blank"
                    title={attachment.fileName}>
                    <img
                        className="comment-image sc-rounded shadow"
                        alt={attachment.fileName}
                        src={attachment.attachmentUri}
                    />
                </a>
            </div>
        ) : (
            <a
                download
                href={attachment.attachmentUri}
                rel="noreferrer"
                target="_blank"
                title={`Download ${attachment.fileName}`}>
                <Button
                    className="m-1 p-2 rounded w-33 text-nowrap text-left hide-overflow"
                    color="info">
                    <FontAwesomeIcon size="lg" icon={faFileAlt} />
                    &emsp;
                    <span className="hide-overflow">{attachment.fileName}</span>
                </Button>
            </a>
        )}
    </>
);
export default CommentAttachment;
